export const REPORT_LIST_SUCCESS = 'REPORT_LIST_SUCCESS'
export const REPORT_LIST_FAIL = 'REPORT_LIST_FAIL'
export const REPORT_DELETE_FAIL = 'REPORT_DELETE_FAIL'
export const REPORT_DELETE_SUCCESS = 'REPORT_DELETE_SUCCESS'

export const defaultReportState = {
  reports : null
}
export default (state = defaultReportState, action) => {
  switch (action.type) {
    case REPORT_LIST_SUCCESS:
      return {
        ...state,
        reports: action.payload.data
      }
    case REPORT_LIST_FAIL:
      return {
        ...state,
      }
      case REPORT_DELETE_SUCCESS:
      return {
        ...state
      }
    case REPORT_DELETE_FAIL:
      return {
        ...state
      }
    default:
    return {
      ...state,
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reportReducer.js